// extracted by mini-css-extract-plugin
export default {"lang":"changeLang_lang__UGHOQ"};